<div data-testid="scope-switch" class="adb-segmented" role="radiogroup" aria-label="Companies">
  <button *ngFor="let option of options" type="button" role="radio" class="adb-segmented__option"
          [attr.aria-checked]="option.key === value" [attr.data-testid]="'scope-' + option.key.toLowerCase()"
          (click)="onChange(option.key)">{{ option.label }}</button>
</div>
